module.exports = __webpack_public_path__ + "cd6c777f1945164224dee082abaea03a.woff2";


//////////////////
// WEBPACK FOOTER
// ./node_modules/semantic-ui-css/themes/default/assets/fonts/outline-icons.woff2
// module id = 254
// module chunks = 4